<template>
  <div>

    <div class="flex flex-last">
      <vs-spacer/>
      <div v-if="isSettingMode == true" class="flex">
        <a class="mr-2" style="color: rgb(216, 0, 0); font-weight: 500; font-size:14px;" @click="handleDeletePhotoList">선택삭제</a>
        <span>|</span>
        <a class="ml-2" style="color: #1E0D61; font-weight: 500; font-size:14px;" @click="handleClickEndSetting">닫기</a>
      </div>
      <div v-else>
        <a class="ml-4" style="color: #1E0D61; font-weight: 500; font-size:14px;" @click="handleClickStartSetting">편집</a>
      </div>
    </div>

    <div class="mb-8" v-for="(date, dpIndex) of dailyList">
      <h5 class="w-full mb-4" style="font-size:14px;">{{date}}</h5>
      <vs-row>
        <vs-col v-for="(img, ptIndex) in dailyPhotoList[date]" :key="ptIndex" style="width: calc(50% - 4px)">
          <label v-if="isSettingMode == true" style="display:block; position:relative;" v-model="dailyPhotoList[date][ptIndex]">
            <vs-checkbox class="mt-4 ml-4" style="position: absolute; z-index:1000; background-color:#fff;" @change="()=>{handleChangeCheckBox(img)}"></vs-checkbox>
            <img style="width:calc(100% - 4px); height: calc(50vw - 16px); opacity: 0.5" :src="img.path" />
          </label>
          <img v-else style="width:calc(100% - 4px); height: calc(50vw - 16px); " :src="img.path"/>
        </vs-col>
      </vs-row>
    </div>

  </div>
</template>

<script>
export default {
  name: 'PhotoAlbum',

  computed : {
    dailyList () {
      const keys = Object.keys(this.dailyPhotoList);
      return keys
    }
  },

  data () {
    return {
      isSettingMode: false,
      dailyPhotoList:{},
      deletePhotoList:[],
    }
  },

  async mounted () {
    await this.loadPhotoList()
  },

  methods : {
    async loadPhotoList () {
      await this.$store.dispatch('board/LOAD_PHOTO_LIST', {})
      const photoList = this.$store.state.board.photoList;
      const list = []
      for (const photo of photoList) {
        const date = photo.created_at.substr(0,10)
        photo.isChecked = false

        if (!list[date]) {
          list[date] = []
        }
        list[date].push(photo)
      }
      this.dailyPhotoList = list
    },

    handleClickStartSetting () {
      this.isSettingMode = true;
    },

    handleClickEndSetting () {
      this.isSettingMode = false;
    },


    async handleDeletePhotoList () {
      const fileIds = []
      for (const photo of this.deletePhotoList) {
        fileIds.push(photo.id)
      }

      if (fileIds.length > 0) {
        await this.$store.dispatch('board/DELETE_PHOTO_LIST', {fileIds})
        alert('삭제되었습니다.')
        location.reload()
      } else {
        alert('선택된 이미지가 없습니다.')
      }

    },

    handleChangeCheckBox (photo) {
      photo.isChecked = !photo.isChecked
      if (photo.isChecked) {
        this.deletePhotoList.push(photo)
      } else {
        this.deletePhotoList.remove(photo)
      }
    }
  }
}
</script>

<style>
.vs-image .imag-blur {
  height:100%;
}
</style>
<style scoped>

</style>
